import { TypedUseSelectorHook, useSelector } from 'react-redux'
import { RootState } from './reducers/index.reducer'

/**
 * Will config dispatch with Typescript
 */
// export const useAppDispatch = () => useDispatch<AppDispatch>()

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
